import { format } from "date-fns";
import api from "../services/api";

interface IReportResponse {
    codeResult: string;
    data: any[];
}

export interface ISummaryMonthParams {
    year: number;
    month: number;
    regionalId: string;
    sectorId: string;

}

export interface ISummaryMonthResponse {
    acertos: number;
    cadastros: number;
    vendaMinima: number;
    brutoVendido: number;
    naoUsados: number;
    totalPedidos: number;
    debitosConferencia: number;
    naoRetornou: number;
}


class ReportsRepository {
    public async SummaryMonth({ year, month, regionalId, sectorId }: ISummaryMonthParams): Promise<ISummaryMonthResponse> {
        const initialDate = format(new Date(year, (month - 1), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(year, month, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const initialDate1 = format(new Date(year, (month + 1), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate1 = format(new Date(year, (month + 1), 16, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Kit", "Conference", "Pedido", "GerenteRegional", "GerenteSetor", "Representante"],
            "sql": [
                {
                    "coderesult": "TotalAcertos",
                    "query": `SELECT COUNT(Conference.kitId) as TotalAcertos 
                    FROM Conference 
                    INNER JOIN Representante 
                    ON Representante.id = Conference.representanteId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId
                    INNER JOIN GerenteRegional 
                    ON GerenteRegional.id = GerenteSetor.gerenteRegionalId 
                    WHERE Conference.conferenceType = 0 
                    AND Conference.data >= "${initialDate}" 
                    AND Conference.data < "${endDate}" 
                    ${regionalId.length > 0 ? `AND GerenteRegional.id = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND GerenteSetor.id = '${sectorId}' ` : ""}`
                },
                {
                    "coderesult": "CadastroRealizado",
                    "query": `SELECT COUNT(Kit.id) as Cadastros 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Kit.tipo = 0 
                    AND Kit.dataEntrega >= "${initialDate}" 
                    AND Kit.dataEntrega < "${endDate}" 
                    ${regionalId.length > 0 ? `AND Pedido.gerenteRegionalId = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND Pedido.gerenteSetorId = '${sectorId}' ` : ""}`
                },
                {
                    "coderesult": "TotalVendaMinima",
                    "query": `SELECT COUNT(Conference.kitId) as TotalVendaMinima 
                    FROM Conference 
                    INNER JOIN Representante 
                    ON Representante.id = Conference.representanteId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId
                    INNER JOIN GerenteRegional 
                    ON GerenteRegional.id = GerenteSetor.gerenteRegionalId 
                    WHERE Conference.conferenceType = 0 
                    AND Conference.valorVendido >= 50 
                    AND Conference.data >= "${initialDate}" 
                    AND Conference.data < "${endDate}" 
                    ${regionalId.length > 0 ? `AND GerenteRegional.id = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND GerenteSetor.id = '${sectorId}' ` : ""}`
                },
                {
                    "coderesult": "TotalBrutoVendido",
                    "query": `SELECT SUM(Conference.valorVendido) as TotalBrutoVendido 
                    FROM Conference 
                    INNER JOIN Representante 
                    ON Representante.id = Conference.representanteId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId
                    INNER JOIN GerenteRegional 
                    ON GerenteRegional.id = GerenteSetor.gerenteRegionalId 
                    WHERE Conference.conferenceType = 0 
                    AND Conference.data >= "${initialDate}" 
                    AND Conference.data < "${endDate}"
                    ${regionalId.length > 0 ? `AND GerenteRegional.id = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND GerenteSetor.id = '${sectorId}' ` : ""}`
                },
                {
                    "coderesult": "NaoUsados",
                    "query": `SELECT COUNT(Conference.kitId) as NaoUsados 
                    FROM Conference 
                    INNER JOIN Kit 
                    ON Kit.id = Conference.kitId 
                    INNER JOIN Representante 
                    ON Representante.id = Conference.representanteId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId 
                    INNER JOIN GerenteRegional 
                    ON GerenteRegional.id = GerenteSetor.gerenteRegionalId 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Conference.conferenceType = 0 
                    AND Conference.data >= "${initialDate}" 
                    AND Conference.data < "${endDate}" 
                    AND Pedido.acerto >= "${initialDate1}" 
                    AND Pedido.acerto < "${endDate1}" 
                    AND Kit.tipo = 1 
                    ${regionalId.length > 0 ? `AND GerenteRegional.id = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND GerenteSetor.id = '${sectorId}' ` : ""}`
                },
                {
                    "coderesult": "TotalPedidos",
                    "query": `SELECT COUNT(Kit.id) as TotalPedidos 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId
                    INNER JOIN Representante 
                    ON Representante.id = Pedido.representanteId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId 
                    INNER JOIN GerenteRegional 
                    ON GerenteRegional.id = GerenteSetor.gerenteRegionalId                      
                    WHERE Pedido.acerto >= "${initialDate1}" 
                    AND Pedido.acerto < "${endDate1}"
                    AND Kit.tipo = 1 
                    ${regionalId.length > 0 ? `AND GerenteRegional.id = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND GerenteSetor.id = '${sectorId}' ` : ""}`
                },
                {
                    "coderesult": "TotalDebitoConferencia",
                    "query": `SELECT SUM(valorReceber) - SUM(valorRecebido) as TotalDebitoConferencia 
                    FROM Conference 
                    INNER JOIN Representante 
                    ON Representante.id = Conference.representanteId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId
                    INNER JOIN GerenteRegional 
                    ON GerenteRegional.id = GerenteSetor.gerenteRegionalId 
                    WHERE Conference.conferenceType = 0 
                    AND Conference.data >= "${initialDate}" 
                    AND Conference.data < "${endDate}"
                    ${regionalId.length > 0 ? `AND GerenteRegional.id = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND GerenteSetor.id = '${sectorId}' ` : ""}`
                },
                {
                    "coderesult": "TotalKitNaoRetornou",
                    "query": `SELECT COUNT(Kit.id) as TotalKitNaoRetornou 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Kit.estado = 2 
                    AND Pedido.acerto >= "${initialDate}" 
                    AND Pedido.acerto < "${endDate}" 
                    ${regionalId.length > 0 ? `AND Pedido.gerenteRegionalId = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND Pedido.gerenteSetorId = '${sectorId}' ` : ""}`
                }
            ]
        };

        const response = await api.post<IReportResponse[]>("reports", body);
        console.log(response);
        return {
            acertos: this.GetFromCodeResult(response.data, "TotalAcertos")[0].TotalAcertos,
            cadastros: this.GetFromCodeResult(response.data, "CadastroRealizado")[0].Cadastros,
            vendaMinima: this.GetFromCodeResult(response.data, "TotalVendaMinima")[0].TotalVendaMinima,
            brutoVendido: this.GetFromCodeResult(response.data, "TotalBrutoVendido")[0].TotalBrutoVendido,
            naoUsados: this.GetFromCodeResult(response.data, "NaoUsados")[0].NaoUsados,
            totalPedidos: this.GetFromCodeResult(response.data, "TotalPedidos")[0].TotalPedidos,
            debitosConferencia: this.GetFromCodeResult(response.data, "TotalDebitoConferencia")[0].TotalDebitoConferencia,
            naoRetornou: this.GetFromCodeResult(response.data, "TotalKitNaoRetornou")[0].TotalKitNaoRetornou
        };
        
    }
    
    GetFromCodeResult(data: IReportResponse[], codeResult: string) {
        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const reportsRepository = new ReportsRepository();
export default reportsRepository;